/**
 * chat_widget/src/widget/ui/App.tsx
 */

import { useState } from "react";
import type { WidgetInitOptions } from "../types/widgetTypes";
import { ChatPanel } from "./ChatPanel";
import chatbotIcon from "../../assets/chatbot.svg";
import { useChatPanel } from "../hooks/useChatPanel";
import { isBlockedUserAgent } from "../utils/isBlockedUserAgent";

export function App({ options }: { options: WidgetInitOptions }) {
  const launcherPosition = String(options.position).toLowerCase() === "left" ? "left" : "right";
  const [showLauncherMessage, setShowLauncherMessage] = useState(true);
  const avatar = options.avatar;
  const {
    input,
    setInput,
    loading,
    messages,
    bodyRef,
    onSend,
    selectedCar,
    setSelectedCar,
    onMoreInfo,
    onMoreInfoGarage,
    onBookTestDrive,
    getVehicleDetails,
    refreshSession,
    agentName,
    lang,
    attachedCar,
    formActive,
    clearAttachedCar,
    scrollToBottom,
    open,
    setOpen,
    showBadge,
    setFormActive,
    onBooked,
  } = useChatPanel({
    userId: options.userId,
    services: options.services,
  });

  if (!open) {
    return (
      <div className={`vcw-launcher-wrapper vcw-launcher-wrapper--${launcherPosition}`}>
        {showLauncherMessage && (
          <div
            className={`vcw-launcher-message vcw-launcher-message--${launcherPosition}`}
            role="status"
            aria-live="polite"
            onClick={(event) => {
            if (!event?.isTrusted) {
              console.warn("[widget] blocked non-trusted event");
              return;
            }

            if (isBlockedUserAgent()) {
              console.warn("[widget] blocked bot or missing user-agent");
              return;
            }
            setShowLauncherMessage(false)
            setOpen(true);
          }}
          >
            <p className="vcw-launcher-message-text">
              Bonjour 👋 Je suis votre assistant IA. Comment puis-je vous aider ?
            </p>
            <button
              className="vcw-launcher-message-close"
              type="button"
              aria-label="Fermer le message"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowLauncherMessage(false);
              }}
            >
              ×
            </button>
          </div>
        )}

        <button
          className="vcw-launcher"
          onClick={(event) => {
            if (!event?.isTrusted) {
              console.warn("[widget] blocked non-trusted event");
              return;
            }

            if (isBlockedUserAgent()) {
              console.warn("[widget] blocked bot or missing user-agent");
              return;
            }

            setOpen(true);
          }}
          aria-label="Ouvrir le chat"
          type="button"
        >
          <img src={chatbotIcon} alt="" className="vcw-launcher-icon" />
          {showBadge && <div className="vcw-launcher-badge" />}
        </button>
      </div>
    );
  }

  return (
    <ChatPanel
      onClose={() => setOpen(false)}
      actions={options.actions}
      input={input}
      setInput={setInput}
      loading={loading}
      messages={messages}
      bodyRef={bodyRef}
      onSend={onSend}
      selectedCar={selectedCar}
      setSelectedCar={setSelectedCar}
      onMoreInfo={onMoreInfo}
      onMoreInfoGarage={onMoreInfoGarage}
      onBookTestDrive={onBookTestDrive}
      getVehicleDetails={getVehicleDetails}
      refreshSession={refreshSession}
      agentName={agentName}
      lang={lang}
      attachedCar={attachedCar}
      formActive={formActive}
      clearAttachedCar={clearAttachedCar}
      scrollToBottom={scrollToBottom}
      setFormActive={setFormActive}
      onBooked={onBooked}
      avatar={avatar}
    />
  );
}
